import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';
import { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { expireAuth } from '../features/singin/singin-slice';
const newrelic = (window as any).newrelic;

export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => next => action => {
  if (action.type.includes('oyaApi/executeMutation/rejected')) {
    const error = action.payload.data?.message
      ? action.payload.data?.message
      : `Error on request ${action.meta.baseQueryMeta.request.url}`;
    newrelic?.noticeError(`[Anamnese] ${error}`, action.meta);
    if (
      action.meta.baseQueryMeta.response.ok == false &&
      (action.meta.baseQueryMeta.response.status == 401 || action.meta.baseQueryMeta.response.status == 403)
    ) {
      api.dispatch(expireAuth(true));
    }
  }
  return next(action);
};

// Create our baseQuery instance
const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_OYA_CARE_ANAMNESE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).singIn.auth.oya_oyana_access_token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
  headers: {
    'Content-type': 'application/json'
  }
});

export const api = createApi({
  reducerPath: 'oyaAnamneseApi',
  baseQuery: baseQuery,
  endpoints: () => ({})
});
